import { lensConfigurationSteps } from "@/apiUtils/constants";
import { FilterType } from "@/common/lib/types";
import ConfiguratorSettings from "./default.json";

export const LensSlugValue: Record<string, string> = {
  "1.5": "15",
  "1.56": "156",
  "1.59": "159",
  "1.6": "16",
  "1.67": "167",
};

interface ConfiguratorSettingsType {
  sanityMappings: {
    /**Lens types mapped on sanity lens type configs */
    lensTypes: Record<string, string>;
    /**Lens add on option values mapped on sanity lens type configs */
    lensAddOnOptionValue: Record<string, string>;
    lensAdditionalOptions: Record<"UV_PROTECTION" | "BLUE_LIGHT" | "TRANSITION", string>;
    /**Lens index values mapped on sanity lens type configs */
    lensIndexValue: Record<string, string>;
    /** lens design values mapping*/
    lensDesignValues: Record<string, string>;
  };
  translationMappings: {
    /**Step titles keys on translation */
    stepTitles: Record<lensConfigurationSteps, string>;
  };
  configuratorMappings: {
    /** Attribute value property key to be used for attribute value */
    attributeValueProperty: "name" | "slug";
    /** Attribute name property key to be used for attribute name */
    attributeNameProperty: "name" | "slug";
    lensPowerAttributeNames: Record<"SPHERICAL" | "CYLINDRICAL", string>;
    metadataKeys: Record<
      "LENS_TYPE" | "LENS" | "ADDITIONAL_OPTIONS" | "PRESCRIPTION" | "EYE" | "FRAME_ONLY",
      string
    >;
    metadataValues: Record<
      "OS" | "OD" | "SEND_LATER" | "UPLOADED" | "SAVED" | "FRAME_ONLY",
      string
    >;
    applicableProductTypes: string[];
    /** Lens Types */
    lensTypes: Record<"SINGLE_VISION" | "FRAME_ONLY" | "COMPUTER", string>;
    /** Design attribute slug values*/
    designOptions: Record<string, string>;
    /** Index attribute slug values */
    indexOptions: Record<string, string>;
    /** Attribute slug names for filter */
    propertySlugs: Record<string, string>;
    /** Slug value mapped to predefined properties */
    slugPropertyMappings: Record<string, string>;
    /** Customizable properties (uppercase attribute name as values) */
    customizableProperties: Record<string, string>;
    /**Transition lenses types */
    transitionOptions: string[];
    /** lens configurator steps */
    lensConfiguratorSteps: Record<string, string>;
    /** lens configuration steps mapped to lens types */
    lensConfigSteps: Record<string, lensConfigurationSteps[]>;
    /** Default values for filtering computer lens */
    computerLensDefaults: Record<"DESIGN" | "INDEX" | "DESIGN_SLUG" | "INDEX_SLUG", string>;
    /** Default filters for all lenses */
    defaultFilters: Record<string, any[]>;
  };
  settings: {
    /** disable advanced customization option */
    disableAdvancedCustomization: boolean;
    /** disable business rules to filter addons */
    disableBusinessRules: boolean;
    /** Custom filters for steps */
    customFilters: Record<lensConfigurationSteps, FilterType[]>;
    /** Steps that have summary configured */
    summarizableSteps: lensConfigurationSteps[];
    /** Steps that are logged in user only steps */
    userSteps: lensConfigurationSteps[];
    /** Slug seperator for attribute slug generation,
     *  default is "_" switch to different seperator if
     *  attribute slugs includes the current seperator */
    slugSeperator: string;
    /**  Map of steps to be displayed as different step in header */
    indexParser: Record<string, lensConfigurationSteps>;
    /** Round off index for percentage values */
    percentileRoundOff: number;
    /** Round off index for price properties */
    priceRoundOff: number;
  };
}

const {
  sanityMappings: {
    lensTypes: sanityLensTypeMap,
    lensAddOnOptionValue,
    lensAdditionalOptions,
    lensIndexValue,
    lensDesignValues,
  },
  translationMappings: { stepTitles },
  configuratorMappings: {
    attributeValueProperty,
    attributeNameProperty,
    lensPowerAttributeNames,
    metadataKeys,
    metadataValues,
    applicableProductTypes,
    lensTypes,
    customizableProperties,
    indexOptions,
    designOptions,
    propertySlugs,
    slugPropertyMappings,
    lensConfiguratorSteps,
    lensConfigSteps,
    transitionOptions,
    computerLensDefaults,
    defaultFilters,
  },
  settings: {
    disableAdvancedCustomization,
    disableBusinessRules,
    customFilters,
    summarizableSteps,
    userSteps,
    slugSeperator,
    indexParser,
    percentileRoundOff,
    priceRoundOff,
  },
} = ConfiguratorSettings as ConfiguratorSettingsType;

export {
  applicableProductTypes,
  attributeNameProperty,
  attributeValueProperty,
  computerLensDefaults,
  customFilters,
  customizableProperties,
  defaultFilters,
  designOptions,
  disableAdvancedCustomization,
  disableBusinessRules,
  indexOptions,
  indexParser,
  lensAdditionalOptions,
  lensAddOnOptionValue,
  lensConfigSteps,
  lensConfiguratorSteps,
  lensDesignValues,
  lensIndexValue,
  lensPowerAttributeNames,
  lensTypes,
  metadataKeys,
  metadataValues,
  percentileRoundOff,
  priceRoundOff,
  propertySlugs,
  //unused items
  sanityLensTypeMap,
  slugPropertyMappings,
  slugSeperator,
  stepTitles,
  summarizableSteps,
  transitionOptions,
  userSteps,
};
